import { c as _c } from "react/compiler-runtime";
import { Footer } from '@/sections/layout/Footer';
import { PropsWithChildren } from 'react';
import { LINKS } from '@/constants/links';
import { GcssHeader } from '@/sections/layout/Header';
import { useRouter } from 'next/router';
import { Search } from '@/sections/gcss/Search';
import { SearchFormValuesGCSS } from '@/sections/gcss/hooks/useGcssSearch';
import { SeoHeader } from '../SeoHeader';
import { FormApi } from 'final-form';
import { Discover } from '@/sections/gcss/Discover';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { mergeClasses } from '@/utils/style';
type SearchForm = FormApi<SearchFormValuesGCSS, Partial<SearchFormValuesGCSS>>;
interface Props {
  formValues: Partial<SearchFormValuesGCSS>;
  searchForm: SearchForm;
  isHomepage?: boolean;
  handleResetFilter?: () => void;
}
export function GcssLayout(props) {
  const $ = _c(18);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SeoHeader title="" nofollow={true} noindex={true} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.handleResetFilter || $[2] !== router.pathname) {
    t1 = router.pathname !== LINKS().gcssHomepage && <Search onSubmit={props.handleResetFilter} className="3xl:[&_input]:h-12 w-full xl:[&_input]:h-10" />;
    $[1] = props.handleResetFilter;
    $[2] = router.pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <nav><GcssHeader search={t1} /></nav>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = props.isHomepage !== true && "mb-12 lg:mb-24";
  let t4;
  if ($[6] !== t3) {
    t4 = mergeClasses(t3);
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props.children || $[9] !== t4) {
    t5 = <main className={t4}>{props.children}</main>;
    $[8] = props.children;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props.isHomepage) {
    t6 = props.isHomepage !== true && <><SectionDelimiter color="bg-blue-50" background="bg-white" /><Discover /></>;
    $[11] = props.isHomepage;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Footer />;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t5 || $[16] !== t6) {
    t8 = <div>{t0}{t2}{t5}{t6}{t7}</div>;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}